var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2DifferentialSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 45h-3v-7.17l-14.5-15-2.88 2.73L36.79 34H13v19h20.47a6 6 0 005.65 4H42v12h4V57h2.77A6.15 6.15 0 0055 51.75 6.002 6.002 0 0049 45zm-7 0h-3a6 6 0 00-5.65 4H17V38h23.59L42 39.46V45zm4-21h-4V7h4v17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Differential_Switch.e712c575.svg";
export { SvgA2DifferentialSwitch as ReactComponent };